<nav
  class="public-pagination"
  :class="{ 'public-pagination--disabled': disabled }"
  :aria-label="resolvedLabel"
  :aria-disabled="disabled"
>
  <div
    v-if="showPageNavigation"
    class="public-pagination__controls"
  >
    <button
      type="button"
      :disabled="isFirstDisabled"
      @click="$emit('first')"
      :aria-label="$t('common.firstPage')"
    >
      <i class="bi bi-chevron-double-left"></i>
    </button>

    <button
      type="button"
      :disabled="isFirstDisabled"
      @click="$emit('prev')"
      :aria-label="$t('common.previousPage')"
    >
      <i class="bi bi-chevron-left"></i>
    </button>

    <span>{{ $t('common.page', { page, total: totalPages }) }}</span>

    <button
      type="button"
      :disabled="isLastDisabled"
      @click="$emit('next')"
      :aria-label="$t('common.nextPage')"
    >
      <i class="bi bi-chevron-right"></i>
    </button>

    <button
      type="button"
      :disabled="isLastDisabled"
      @click="$emit('last')"
      :aria-label="$t('common.lastPage')"
    >
      <i class="bi bi-chevron-double-right"></i>
    </button>
  </div>

  <div
    v-if="showPageSize"
    class="public-pagination__page-size-group"
  >
    <span
      v-if="showPageSizeLabel"
      class="public-pagination__page-size-label"
    >
      {{ resolvedPageSizeLabel }}
    </span>

    <label class="public-pagination__page-size">
      <select
        v-model.number="selectedPageSize"
        :disabled="disabled"
        :aria-label="$t('common.pageSizeAria')"
      >
        <option
          v-for="option in normalizedPageSizeOptions"
          :key="option"
          :value="option"
        >
          {{ option }}
        </option>
      </select>
    </label>
  </div>
</nav>
